import { useQueryClient } from "react-query";
import { defaultContextState, useStateContext } from "../contexts/ContextProvider";
import posthog from "../lib/posthog";
import { markVoluntaryLogout } from "../helpers/voluntaryLogout";

function buildLoginPathWithSlug(slug: string | null | undefined) {
    const { hostname } = window.location;
    const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
    const isApp = hostname === "app.trigger-flow.com" || hostname === "guestaccount.app";
    // On n'ajoute /slug que sur les domaines neutres (comme tu le fais déjà ailleurs)
    if (slug && (isLocal || isApp)) return `/login/${slug}`;
    return `/login`;
}

/**
 * Nettoyage local d'une fin de session, partagé par la déconnexion simple et
 * par « déconnecter tous mes appareils » : les deux doivent laisser exactement
 * le même état derrière elles.
 */
export function useSessionTeardown() {
    const { setUser, setToken, user } = useStateContext();
    const queryClient = useQueryClient();

    return () => {
        markVoluntaryLogout();
        posthog.reset();
        setUser(defaultContextState.user);
        // setToken(null) purge déjà ACCESS_TOKEN et les clés qui l'accompagnent
        // (ContextProvider.handleSetToken) — ne pas doubler ici, ce serait n'en
        // connaître qu'une sur trois.
        setToken(null);
        // Réinitialise proprement le cache
        queryClient.clear();

        // Full page reload pour éviter les erreurs de chunks obsolètes après déploiement
        window.location.href = buildLoginPathWithSlug(user?.loyalty_program_slug ?? null);
    };
}
